import React from 'react';
import PropTypes from 'prop-types';

export const Success = ({
  message,
  info: { success, toContinue, youreSignedIn },
}) => (
  <div className='center min-vh-100 success-container'>
    <div className='flex flex-column'>
      <div className='mh4 mw5 mb1 self-center flex flex-column items-center justify-center'>
        <img
          className='mw5'
          src={require('assets/img/logo-no-bg.png')}
          style={{ objectFit: 'contain', maxHeight: '1.2rem' }}
          alt='logo'
        />
      </div>
      <div className='flex flex-column'>
        <div className='br2 pa3 white mv3 tc login-header'>{message}</div>
      </div>
      <div className='flex flex-column container tc white success__element'>
        <div className='success__check'>
          <img src={require('assets/sso/check.png')} alt='check' />
          <span className='success__check--message'>
            {success}
            !
          </span>
        </div>
        <div className='success__comments'>
          <p>{youreSignedIn}</p>
          <p>{toContinue}</p>
        </div>
      </div>
    </div>
  </div>
);

Success.propTypes = {
  message: PropTypes.string.isRequired,
  info: PropTypes.object,
  success: PropTypes.string,
  toContinue: PropTypes.string,
  youreSignedIn: PropTypes.string,
};
